<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <div
      id="auditTop"
      class="main-page-content"
      v-show="$route.matched.length == 2"
    >
      <PageHeaderLayout>
        <div class="content-tip">
          tip:数据每月进行更新，更新完成后需重新提交交付
        </div>
        <div style="background: #fff; padding: 20px 20px">
          <el-form
            :inline="true"
            :model="searchCondition"
            class="demo-form-inline"
          >
            <el-form-item label="任务名称">
              <el-input
                clearable
                v-model="searchCondition.recruit_post"
                placeholder="请输入任务名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select
                clearable
                v-model="searchCondition.examine_status"
                placeholder="审核状态"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
          <div
            style="marrgin: 0 20px"
            v-loading="loading"
            element-loading-text="玩命加载中……"
            element-loading-spinner="el-icon-loading"
          >
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{ background: '#fbfbfb' }"
            >
              <el-table-column
                prop="title"
                label="任务名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="channel_name"
                label="服务公司"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="deliver_num"
                label="交付人数"
                align="center"
              ></el-table-column>
              <el-table-column
                key="created_at1"
                prop="created_at"
                label="任务发布时间"
                align="center"
              ></el-table-column>

              <el-table-column
                prop="examine_status"
                label="状态"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.examine_status == "0"
                      ? "审核中"
                      : scope.row.examine_status == "1"
                      ? "审核成功"
                      : scope.row.examine_status == "2"
                      ? "审核失败"
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleBatchUpload(scope.row)"
                    style="margin-right: 10px;"
                    >{{
                      scope.row.deliver_upload_status == 1 ? "编辑" : "批量上传"
                    }}</el-button
                  >
                  <el-button size="mini" @click="taskClick(scope.row)"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <el-dialog
          title="任务描述"
          :visible.sync="taskseedialogVisible"
          width="30%"
          @close="userClose"
        >
          <div>
            {{ mission_content }}
          </div>
          <div style="text-align: center; margin-top: 20px">
            <span slot="footer" class="dialog-footer">
              <el-button
                @click="taskseedialogVisible = false"
                size="mini"
                type="primary"
                >确 认</el-button
              >
            </span>
          </div>
        </el-dialog>
        <el-dialog
          title=""
          :visible.sync="examinedialogVisible"
          width="50%"
          @close="userClose"
        >
          <el-radio-group v-model="radio">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核拒绝</el-radio>
          </el-radio-group>
          <div v-if="radio == 2" style="margin-top: 30px">
            <el-form
              :model="userList"
              label-width="90px"
              :rules="userRules"
              ref="userRef"
            >
              <el-form-item prop="textarea">
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="userList.textarea"
                  maxlength="100"
                  show-word-limit
                  :rows="5"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="examinedialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="userInfo">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
          title="批量上传"
          :visible.sync="uploadDialog.show"
          width="50%"
          @close="closeUploadDialog"
        >
          <div class="shenhe-content-tip">
            tip:请认真核对任务说明及上传的相关图片资料，全面核查业务相关信息；税务部门将对业务真实性开展不定期抽查，确保业务开展合规有序。
          </div>
          <div class="text-content">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="uploadDialog.form.deliver_content"
              autosize
            >
            </el-input>
          </div>

          <div class="img-content">
            <UploadImg ref="uploadImgRef" :multiple="false" />
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeUploadDialog" style="margin-right: 24px;"
              >取 消</el-button
            >
            <el-button type="primary" @click="UploadSave">确 定</el-button>
          </span>
        </el-dialog>
        <el-pagination
          style="float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagege.current_page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagege.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagege.total"
        ></el-pagination>
      </PageHeaderLayout>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import UploadImg from "@/components/uploadImg/index.vue";
export default {
  components: {
    DatePicker,
    PageHeaderLayout,
    UploadImg,
  },
  data() {
    var checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入失败原因!"));
      } else {
        callback();
      }
    };
    return {
      shenheData: [],
      options: [
        {
          value: "0",
          label: "审核中",
        },
        {
          value: "1",
          label: "审核成功",
        },
        {
          value: "2",
          label: "审核失败",
        },
      ],
      searchCondition: {},
      pagege: {},
      currentPage2: "",
      id: "",
      Status: "",
      mission_content: "",
      loading: false,
      userList: {
        textarea: "",
      },
      radio: 1,
      examinedialogVisible: false,
      taskseedialogVisible: false,
      tableData: [],
      ispage: 1,
      num: 10,
      userRules: {
        textarea: [{ required: true, validator: checkName, trigger: "blur" }],
      },
      uploadDialog: {
        show: false,
        form: {
          deliver_content: "",
          deliver_images: [],
        },
        data: {},
      },
    };
  },
  created() {
    this.init();
  },

  methods: {
    async UploadSave() {
      let imgs = this.$refs.uploadImgRef.getImagesList();
      console.log(imgs, "imgs");
      let params = {
        deliver_content: this.uploadDialog.form.deliver_content,
        deliver_images: imgs.join(","),
        deliver_upload_status: 1,
      };
      if (params.deliver_images.length === 0) {
        this.$message.warning("请上传图片");
        return;
      }
      if (params.deliver_content.length === 0) {
        this.$message.warning("请输入内容");
        return;
      }

      await this.$api.post_deliver_privatejoinAutoExamine(
        this.uploadDialog.data.id,
        params
      );
      this.$message.success("上传成功");
      this.closeUploadDialog();
      this.init();
    },
    openUploadDialog() {
      this.uploadDialog.show = true;
      setTimeout(() => {
        this.uploadDialog.data.deliver_images = this.uploadDialog.data.deliver_images?.split(
          ","
        );
        this.$refs.uploadImgRef.setImagesList(
          this.uploadDialog.data.deliver_images
        );
      }, 100);
    },
    closeUploadDialog() {
      this.$refs.uploadImgRef.setImagesList([]);
      this.uploadDialog.show = false;
      this.uploadDialog.form = {};
      this.uploadDialog.data = {};
    },
    handleBatchUpload(row) {
      console.log(row);
      let data = JSON.parse(JSON.stringify(row));
      this.openUploadDialog();
      this.uploadDialog.data = data;
      this.uploadDialog.form.deliver_images =
        data.deliver_images?.split(",") || "";
      this.uploadDialog.form.deliver_content = data.deliver_content || "";
    },
    // 搜索
    searchButton() {
      this.init();
    },
    //获取选中日期的值
    dataSearch(value) {
      console.log(value);
      this.searchCondition.time = {};
      this.searchCondition.time.start_time = value[0];
      this.searchCondition.time.end_time = value[1];
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.num = val;
      this.ispage = 1;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.ispage = val;
      this.init();
    },
    //详情
    taskClick(row) {
      this.$router.push({
        path: "/deliveryReview/deliveryPrivatePersonnelList",
        query: { id: row.id },
      });
    },
    async init() {
      let objects = {
        current_page: this.ispage,
        page_size: this.num,
        examine_status: this.searchCondition.examine_status,
        time: this.searchCondition.time,
      };
      let res = {};
      this.loading = true;
      res = await this.$api.getMissionList({
        ...objects,
        title: this.searchCondition.recruit_post,
      });
      let { list, pages } = res;

      this.tableData = list;
      this.pagege = pages;
      this.loading = false;
    },

    taskseeClick(row) {
      this.mission_content = row.mission_content || row.job_remark;
      console.log(row);
      this.taskseedialogVisible = true;
    },
    userClose() {},
    examineClick(row) {
      this.id = row.id;
      this.radio = 1;
      this.userList.textarea = "";
      this.examinedialogVisible = true;
    },
    async userInfo() {
      let obj = {
        examine_status: this.radio,
        examine_reason: this.userList.textarea,
      };
      console.log(obj, "obj");

      if (obj.examine_status == 2 && obj.examine_reason == "") {
        this.$message.error("请填写拒绝理由");
      } else {
        let Status = await this.$api.postStatus(this.id, obj);

        this.$nextTick(() => {
          if (Status) {
            this.$message.success("审核成功!");
            this.init();
            this.examinedialogVisible = false;
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main-page-content {
  padding-bottom: 50px;
}
.text-content {
  width: 500px;
  min-height: 120px;
  background-color: #f2f3f7;
  border-radius: 24px;
  padding: 24px;
  ::v-deep .el-textarea__inner {
    height: 100% !important;
    background-color: #f2f3f7;
    border: none !important;
    resize: none !important;
    padding: 0 !important;
  }
}
.img-content {
  margin-top: 24px;
  .item-img {
    margin-bottom: 24px;
  }
  .img-icon {
    width: 500px;
    height: auto;
  }
}
.shenhe-content-tip {
  margin-bottom: 20px;
  font-size: 12px;
  color: red;
}
.content-tip {
  font-size: 16px;
  color: red;
}
</style>
